<template>
    <a :href="'/project/' + project.project_uri">
        <div class="card border-0 shadow-sm">
            <div class="custom-overlay">
                <img v-if="project.youtube_link" :src='"https://img.youtube.com/vi/"+ videoThumbnail(project.youtube_link) + "/mqdefault.jpg"' alt=""  class="card-img-top">
                <img v-else :src="project.project_thumbnail" alt="" class="card-img-top">
                <div class="custom-overlay-items">
                    <div class="project-name">{{ project.project_title }}</div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "project-box",
    props: {
        project: {
            type: Object,
            required: true,
        }
    },
    methods: {
        videoThumbnail(url) {
            if(url.includes("v=")) {
                const id = url.split('v=')[1];
                if (id.includes("&")) {
                    return id.split('&')[0];
                } else {
                    return id
                }
            } else {
                const unique_id = url.split("/")
                return unique_id[unique_id.length - 1]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    margin: 1rem 0.5rem;
    & img {
        height: 175px;
    }
    & .custom-overlay {
        position: relative;
        & .custom-overlay-items {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0.5);
            opacity: 0;
            & .project-name {
                width: 100%;
                text-align: left;
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 0.5rem 1rem;
                color: white;
                font-weight: 500;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;  
                overflow: hidden;
                margin-right: auto;
            }
        }
    }
}

.card:hover {
    & .custom-overlay {
        & .custom-overlay-items {
            opacity: 1;
        }
    }
}
</style>